import styled from 'styled-components';
import Button from 'components/ui-components/Button';
import { CircleTick } from 'assets/icons';
import { ctaGreen, white } from '../../../constants/variables';

const ResetPasswordConfirmation = ({ onResend }) => (
  <ConfirmationWrapper className="ta-c pb-54">
    <h1 className="ff-rc fw-700 fs-30 l-fs-36 lh-1-2 l-lh-1 tc-main mb-24 mt-52 fl fl-col m-fl-row jc-c ai-c g-14">
      <CircleTick
        fillColorMain={ctaGreen}
        fillColorSecondary={white}
        width={45}
        height={45}
      />
      <span>Password Reset Link Sent</span>
    </h1>
    <p className="fs-18 lh-1-25 tc-secondary m-fb-60 mb-40">
      If your account details are correct, you will receive instructions to
      reset your password via email.
    </p>
    <p className="ff-rc fs-20 tc-main fw-700 mb-12">
      Didn&apos;t receive an email?
    </p>
    <p className="fs-16 lh-1-5 tc-secondary m-fb-60 mb-24">
      Please check your spam folder or go back to the reset password form to
      edit your details.
    </p>
    <Button
      className="cef-btn cef-btn--grey cef-btn--feature margin-center"
      handleClick={onResend}>
      Back to Password Form
    </Button>
  </ConfirmationWrapper>
);

const ConfirmationWrapper = styled.div`
  min-height: 50vh;
`;

export default ResetPasswordConfirmation;
